export const cilFunctionsAlt = ["24 24","<path d='M16.875 6v-1.5h-10.875v2.545l4.602 4.955-4.602 4.955v2.545h10.875v-1.5h-9.375v-0.455l5.148-5.545-5.148-5.545v-0.455h9.375z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-functions-alt.js
// module id = null
// module chunks = 